import { render, staticRenderFns } from "./FootPC.vue?vue&type=template&id=71df73aa&scoped=true&lang=pug"
import script from "./FootPC.vue?vue&type=script&lang=js"
export * from "./FootPC.vue?vue&type=script&lang=js"
import style0 from "./FootPC.vue?vue&type=style&index=0&id=71df73aa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71df73aa",
  null
  
)

export default component.exports